"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSettings = void 0;
var WebSettings = (function () {
    function WebSettings() {
        this.leftMargin = 0;
        this.topMargin = 0;
        this.rightMargin = 0;
        this.bottomMargin = 0;
        this.id = 1;
    }
    WebSettings.prototype.isBodyMarginsSet = function () {
        return this.leftMargin != 0 || this.topMargin != 0 || this.rightMargin != 0 || this.bottomMargin != 0;
    };
    WebSettings.prototype.clone = function () {
        var result = new WebSettings();
        result.leftMargin = this.leftMargin;
        result.topMargin = this.topMargin;
        result.rightMargin = this.rightMargin;
        result.bottomMargin = this.bottomMargin;
        result.id = this.id;
        return result;
    };
    return WebSettings;
}());
exports.WebSettings = WebSettings;
